/* eslint-disable */
import React from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import { templateStrings } from "../../../../Constant";
import { selectDateFilter } from "../../../../redux/actions/dateFilterAction";
import { passSettlementDetailsAction } from "../../../../redux/action-creators/distanceReportActionCreator";
import { exportExcel, getListUtil } from "../../../../shared/utils";
import SettlementDetails from "../../../../shared/components/commonComponents/SettlementDetails";

class PassSettlementDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNo: 0,
      rowsPerPage: 10,
      count: 100,
      backdrop: false,
      totalPages: 0,
      sortBy: "",
      selected: [],
      showUploadXlsxModal: false,
    };
  }

  componentDidMount() {
    this.passSettlementGetList();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      (prevProps && prevProps.cityFilter !== this.props.cityFilter)
      || (prevProps && prevProps.operatorFilter !== this.props.operatorFilter)
      || (prevProps && prevProps.dateFilter !== this.props.dateFilter)
    ) {
      this.passSettlementGetList();
    }
  }

  onSortToggle = (value, key) => {
    this.setState(
      {
        sortBy: { [key]: value },
      },
      () => {
        this.passSettlementGetList();
      },
    );
  };

  handleChange = (input, value) => {
    this.setState({ [input]: value }, () => {
      if (input === "pageNo") {
        this.passSettlementGetList();
      }
    });
  };

  downloadExcel = async () => {
    const id = "exportResidualSettlementData";
    const addOnFilter = {
      cityId: get(this, "props.location.state.cityId", ""),
      agencyId: get(this, "props.location.state.agencyId", ""),
      date: {
        fromDate: new Date(
          get(this, "props.location.state.fromDate", null),
        ).getTime(),
        toDate: new Date(
          get(this, "props.location.state.toDate", null),
        ).getTime(),
      },
      operatorFilter: this.props.operatorFilter,
      distributionType: "passRevenue",
    };
    await exportExcel({ id, addOnFilter });
  };

  passSettlementGetList = () => {
    if (
      get(this, "props.location.state.fromDate", null)
      && get(this, "props.location.state.toDate", null)
    ) {
      getListUtil({
        dispatchFn: this.props.fetchPassSettlementDetails,
        props: this.props,
        state: this.state,
        extraParam: "header",
      });
    } else {
      const { history } = this.props;
      history.push("/report/mobile-ticket");
    }
  };

  render() {
    return (
      <SettlementDetails
        inputProps={this.props}
        state={this.state}
        templateString={templateStrings.reportMobileSettlementDetails}
        heading="Pass Distribution"
        downloadExcel={this.downloadExcel}
        handleChange={this.handleChange}
        onSortToggle={this.onSortToggle}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    content:
      (state
        && state.Report
        && state.Report.passSettlementDetails
        && state.Report.passSettlementDetails.data)
      || [],
    totalItems:
      (state
        && state.Report
        && state.Report.passSettlementDetails
        && state.Report.passSettlementDetails.totalItems)
      || 0,
    headerLoader: state && state.loadingBar && state.loadingBar.header,
    dateFilter: state.DateFilter.selectedDateFilter,
    cityFilter: state.Cities.selectedCity,
    operatorFilter: state.Operators.selectedOperator,
  };
}

const mapDispatchToProps = (dispatch, state) => ({
  fetchPassSettlementDetails: (value, loaderScope) => {
    dispatch(passSettlementDetailsAction(value, loaderScope));
  },
  selectDateFilter: (value) => {
    dispatch(selectDateFilter(value));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PassSettlementDetails);
